import { useEffect, useSyncExternalStore } from 'react';
import { gameStore, type Snapshot } from './store';

/** Subscribe a component to every simulation tick. */
export function useGame(): Snapshot {
  return useSyncExternalStore(gameStore.subscribe, gameStore.getSnapshot, gameStore.getSnapshot);
}

/**
 * Drive the loop for the lifetime of the app, and flush a save when the tab
 * is hidden or closed so a refresh never costs progress.
 */
export function useGameLoop(): void {
  useEffect(() => {
    gameStore.start();

    const handleVisibility = (): void => {
      if (document.visibilityState === 'hidden') gameStore.save();
    };
    const handleUnload = (): void => gameStore.save();

    document.addEventListener('visibilitychange', handleVisibility);
    window.addEventListener('pagehide', handleUnload);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
      window.removeEventListener('pagehide', handleUnload);
      gameStore.stop();
    };
  }, []);
}
